'use client'

import { useRouter } from 'next/navigation'
import { useEffect } from 'react'

import { ChainLoader } from '../components/chain-loader'
import { USER_ROUTES } from '../constants/routes'
import { tokenUtils } from '../utils/token-utils'

export default function Home() {
  const router = useRouter()

  useEffect(() => {
    const isAuthenticated = tokenUtils.isAuthenticated()

    if (isAuthenticated) {
      router.push(USER_ROUTES.SHIPMENTS)
    } else {
      router.push('/login')
    }
  }, [router])

  // Show a simple loading state while redirecting
  return <ChainLoader />
}
